import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '../Button/Button';

interface ContactUsButtonProps {
    title: string
}

export const ContactUsButton = ({ title, }: ContactUsButtonProps) => {
    const { t } = useTranslation();

    return (
        <div className='mt-5'>
            <h4 className="text-xl">{title}</h4>

            <br />

            <Link to="/contact-us">
                <Button buttonText= {t('generic.contactUs')} />
            </Link>
        </div>
    );
};